import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'atlas-panel-description',
  templateUrl: './panel-description.component.html',
  styleUrls: ['./panel-description.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PanelDescriptionComponent {}
